
/*
import {Utils} from "../../../utils.js"; 
import Sprite from '../../objects/Sprite.js'

import browser from '../../utils/browser.js' 
 */
import Common from "../../utils/Common.js";
import {ExtendView} from "../../../viewer/ExtendView.js";
import * as THREE from "../../../../libs/three.js/build/three.module.js";
import Viewport from "../../viewer/Viewport.js";
import {ExtendPointCloudMaterial} from "../../../materials/ExtendPointCloudMaterial.js";
import math from "../../utils/math.js";  
//import {Prism} from './Prism.js'
 


const maxWidth = 4096
const surfaceThick = 0.1 ;//最大表面厚度 
const pointDensity = 'screenshot'
const maxPointBudge = Potree.config.pointDensity[pointDensity].pointBudget

const Shaders = {
    'modelHeight.vs':` 
        precision highp float;
        
        uniform vec2 boundZ;
        varying float heightPercent; 
        
  
        
        void main() 
        {      
            vec3 worldPos = (modelMatrix * vec4(position, 1.0)).xyz; 
            gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 ); 
             
            float zMin = boundZ.x, zMax = boundZ.y ;
            heightPercent = (worldPos.z - zMin) / (zMax - zMin);  
            
             
        }
 
        
    `
     ,
    
    'modelHeight.fs': `
        precision highp float;
        varying float heightPercent; 
      
         
            
            
         vec3 percentToByte(float num){
                                            //输出是0-1， shader精度不够，只够存3个数，因第四位总是0
            float a = 1.0;
            float result[4];
            for(int i=0;i<3;i++){
                a = i == 2 ? a/255.0 : a / 256.0 ; 
                                           //分成256份，其中255份给当前位置，最后一份给后一个位置，而到了最后一个位置时没有下一个位置了所以只分成255份
                if(num > a){
                    float c = num / a;
                    float r = floor(c);
                    r = min(255.0, r);
                    result[i] = r;
                    num -= r * a;
                }else{
                    result[i] = 0.0;
                }
            } 
            return vec3(result[0]/255.0, result[1]/255.0,result[2]/255.0);  
             
        } 
    
         
        void main() {
              
               gl_FragColor = vec4(percentToByte(heightPercent),1.0); 
            
             
        }
     `
}


let horizonZ, zMin, zMax, lowest, highest,  wDelta,  sDelta,  deferred,  interrupt, timestamp,
    buffer1, buffer2, modelZs = []
    



let testPoint_ = false


//const asyncTimeout = (delay) => new Promise(resolve => setTimeout(resolve, delay))
const delayForNotify = 5,  notifyInterval = 500  


let lastNotifyTime = Date.now()
let curPercent
const notify = (areas, num, str )=>{ //num: 0-1
    return new Promise(resolve => { 
        if(!deferred)return resolve()
         
        let now = Date.now()
        if(now - lastNotifyTime < notifyInterval){ 
            return resolve()
        } 
        lastNotifyTime = now
        if(num == void 0){
            num = curPercent
        }else{ 
            let s = 0, e = 1
            if(num instanceof Function ){
                num = num()
            }
             
            areas.forEach((area)=>{
                let s_ = e * area[0] + s * (1-area[0])
                let e_ = e * area[1] + s * (1-area[1])
                s = s_, e = e_
            })
            
            let p = e * num + s * (1-num)  
            
            str == 'loadpoints' && Potree.settings.isTest &&  console.log('notify pro', p, str)
            deferred.notify(p) 
            curPercent = p
            if(isNaN(p)){
                console.log('nan')
            }
        }
        setTimeout(resolve, delayForNotify)
    }) 
    
}





export default class VolumeComputer extends THREE.EventDispatcher{
    
    constructor(){
        super()
        
        this.camera = new THREE.OrthographicCamera(-100,100,-100,100 , 0.01, 100);
        this.camera.up.set(0,0,1);
        Potree.Utils.setCameraLayers(this.camera, ['model']); 
        this.view = new ExtendView
        
        this.viewport = new Viewport(this.view,this.camera,{left:0,bottom:0,width:1,height:1})
        this.renderTarget = new THREE.WebGLRenderTarget(
            1, 1,
            { minFilter: THREE.LinearFilter,
                magFilter: THREE.NearestFilter,
                format: THREE.RGBAFormat }
        );
        this.renderTarget2 = new THREE.WebGLRenderTarget(
            1, 1,
            { minFilter: THREE.LinearFilter,
                magFilter: THREE.NearestFilter,
                format: THREE.RGBAFormat }
        );
        this.renderTarget2.texture.name = 'volumeCptModelTex'
        
        this.material = new ExtendPointCloudMaterial();
     
		this.material.activeAttributeName = testPoint_ ? "rgba" : 'heightCpt' ;// 'rgba' indices prismHeight
         
        this.prisms = []
           
        this.modelMat = new THREE.ShaderMaterial({ 
            uniforms:{
                boundZ: {
                    type: "vec2",
                    value: new THREE.Vector2
                } 
            },
            vertexShader: Shaders['modelHeight.vs'],   
            fragmentShader: Shaders['modelHeight.fs'],
            depthWrite: true,
            depthTest: true,
            transparent: false,
            side: THREE.DoubleSide
        })
        
        
        this.scene = new THREE.Scene
        
        
        
    }
    
    init(){
        viewer.scene.addEventListener('measurement_added',(e)=>{
            if(e.measurement.isPrism) this.add(e.measurement)
        })
        viewer.scene.addEventListener('measurement_removed',(e)=>{
            if(e.measurement.isPrism) this.remove(e.measurement)
        }) 
        
 
        let this_ = this
        this.events = {
            transformCallback: ()=>{
                if(!this_.currentPrism)return 
                //Common.intervalTool.isWaiting('volCptTransformed', ()=>{ //延时update，防止卡顿  
                    let object = viewer.transformationTool.selection[0] 
                    if(object == this_.currentPrism.baseModel ){  
                        this.updateModelBound({modelChange:true})  
                    } 
                    this_.currentPrism.dispatchEvent('needsCompute') //模型变动或clipBox变动后要重算 
                //}, 1000)  
                
            },  
        }
    }
    
    enter(){
        this.entered = true 
        viewer.measuringTool.history.clear() //避免撤销到测量线去
        this.oldStates = {
            rotAroundPoint : Potree.settings.rotAroundPoint
        }
        Potree.settings.rotAroundPoint = false
         
        //viewer.objs.traverse(e=>e.material && ( e.material = this.material))
        viewer.transformationTool.addEventListener('stopDrag', this.events.transformCallback)
        viewer.transformationTool.addEventListener('changeByHistory', this.events.transformCallback)
    }
    
    leave(){ 
        this.entered = false
        Potree.settings.rotAroundPoint = this.oldStates.rotAroundPoint
        this.setCurrentPrism(null)
        
        viewer.transformationTool.removeEventListener('stopDrag', this.events.transformCallback) 
        viewer.transformationTool.removeEventListener('changeByHistory', this.events.transformCallback)
    }
    
    add(prism){
        this.prisms.push(prism)
    }
    
    remove(prism){
        let i = this.prisms.indexOf(prism)
        i>-1 && this.prisms.splice(i,1)
    }
    
    cancel(){
        if(this.computingObject){
            interrupt = true 
        }
    }
   
    startCompute(model,dontCompute){//test
        this.enter();
        let deferred = $.Deferred() 
        deferred.done((e)=>{
            console.log('done', e)
        })
        deferred.fail((e)=>{
            console.log('?fail????', e)
        })
        /* deferred.progress((e)=>{
            console.log('progress', e)
        })  */  
        if(model){
            this.prisms[this.prisms.length-1].setBaseModel(model)
            this.setCurrentPrism(this.prisms[this.prisms.length-1])
            dontCompute || this.compute(this.prisms[this.prisms.length-1])  
        }else{
            this.compute(this.prisms[this.prisms.length-1],  deferred )
        } 
    }
    
    
    
   
    setCurrentPrism(prism ){//当进入单个prism编辑后才会高亮点云 
        if(this.currentPrism){
            this.currentPrism.removeEventListeners('updated')
        } 
        this.currentPrism = prism  //允许没有model
        if(!prism || !prism.baseModel/*  || !prism.baseModel.visible */){   
            viewer.scene.pointclouds.forEach(e=>{ 
                this.updateMatForModel(e.material ) //取消高亮
            }) 
            return  
        }  
        
        prism.addEventListener('updated',()=>{
            if(this.currentPrism != prism){
                return  console.log('currentPrism changed? 侦听没删除')
            }
            this.updateModelBound()
        })
        
         
        this.updateModelBound({regetMap:true})
        
    }
     
    setModelMat(model, type){
        if(type == 'recover'){
            model.traverse(e=>e.originMat_ && (e.material = e.originMat_ )) 
        }else{
            model.traverse(e=>e.material && e.material != this.modelMat && ( e.originMat_ = e.material, e.material = this.modelMat ))
        }
    } 
     
     
    updateModelBound({modelChange, regetMap}={}){ //regetMap是在更换currentPrism必须重绘map，但不需要needUpdate
        let prism = this.currentPrism
        let model = this.currentPrism.baseModel
        
        if(!model)return
        model.currentBound = model.boundingBox.clone().applyMatrix4(model.matrixWorld) //作用同prismBound
        let oldBound = model.clipBound && model.clipBound.clone()
       
        model.clipBound = model.currentBound.clone()//高亮范围 
        model.clipBound.min.max(prism.prismBound.min)//xy为交集
        model.clipBound.max.min(prism.prismBound.max)
        model.clipBound.min.z = Math.min(model.currentBound.min.z, prism.prismBound.min.z)//z为并集，范围覆盖prism点、点云、model三者 
        model.clipBound.max.z = Math.max(model.currentBound.max.z, prism.prismBound.max.z)
        this.modelMat.uniforms.boundZ.value.set(model.clipBound.min.z,model.clipBound.max.z)
      
        let boundChanged = !oldBound || !oldBound.equals(model.clipBound)
        
        let boundSize = this.currentPrism.baseModel.clipBound.getSize(new THREE.Vector3)
        this.boundSizeZero = boundSize.x<=0 ||boundSize.y<=0 || boundSize.z<=0  //会造成renderTarget尺寸为0，背景变白，报错：Framebuffer is incomplete: Attachment has zero size 和  The texture is a non-power-of-two texture.
        
        
        if( (modelChange || regetMap || boundChanged) && !this.boundSizeZero){
            this.setModelHeightMap()//包含cad在俯视中的范围 + 高度信息
            //this.setModelMat(model,this.boundSizeZero ? 'recover' : null) 
        } 
        viewer.scene.pointclouds.forEach(e=>{//暂时先只支持一个高亮区域
            this.updateMatForModel(e.material, model) 
        })
        
        //需要重新渲染modelHeightmap的情况：bound改变、模型变动、更换currentPrism后
        //注意，即使上传几种都没发生，仅仅移动prism的marker也要重算，假设一个marker在model范围内，移动后bound可能不变但体积肯定变。
        /* if(boundChanged){
            if(prism.recoverNeedCptNextTime){
                prism.needsCompute = 'byVolume'  //初始化，有volume就不用重算
                prism.recoverNeedCptNextTime = false
            }else{
                prism.dispatchEvent('needsCompute')
            } 
        } */
        
    }
     
    
    updateMatForModel(material, model){
        let oldMap = material.uniforms.baseHeightAreaMap.value 
        if(model){ 
            material.uniforms.baseHeightAreaMap.value = this.renderTarget2.texture    //model.baseHeightAreaMap ;
            material.uniforms.baseHeightBoundZ.value.set(model.clipBound.min.z,model.clipBound.max.z)
            material.uniforms.baseHeightBoundXY.value.set(model.clipBound.min.x, model.clipBound.max.x, model.clipBound.min.y, model.clipBound.max.y)
        }else{
            material.uniforms.baseHeightAreaMap.value = null;
        }
        
        if(oldMap != material.uniforms.baseHeightAreaMap.value ){
            material.shaderNeedsUpdate = true
        } 
    }
    
    
    
    
    setModelHeightMap(){
         
        let oldTarget = viewer.renderer.getRenderTarget()
        let oldParent = this.currentPrism.baseModel.parent
        let oldVisi = this.currentPrism.baseModel.visible
        
        
        let boundSize = this.currentPrism.baseModel.clipBound.getSize(new THREE.Vector3)
          
        let boundCenter = this.currentPrism.baseModel.clipBound.getCenter(new THREE.Vector3)
        let {w, h} = this.getResByBound(boundSize,'forModel')
        
        if(w<=0 || h<=0){
            return console.error('w<=0 || h<=0!!!!!!!!!', w,h)
        }
         
        /* w = THREE.Math.floorPowerOfTwo( w );
        h = THREE.Math.floorPowerOfTwo( h ); */ //for warning：The texture is a non-power-of-two texture
         
        this.camera.far = boundSize.z + 10 
        this.camera.right = w / 2
        this.camera.left = -this.camera.right
        this.camera.top = h / 2
        this.camera.bottom = -this.camera.top 
        this.viewport.resolution.set(w , h)  
        this.renderTarget2.setSize(w, h)
        
        viewer.renderer.setRenderTarget(this.renderTarget2);
        
        console.log('setModelHeightMap')
        
        //最高处朝下看
        
        let endPosition = new THREE.Vector3
        
        endPosition.copy(boundCenter).setZ(this.currentPrism.baseModel.clipBound.max.z + this.camera.near+0.1)
        this.view.pitch = -Math.PI / 2; 
          
        this.view.moveOrthoCamera(this.viewport,  {boundSize , endPosition }, 0)
        this.view.applyToCamera(this.camera) 
        this.scene.add(this.currentPrism.baseModel)
        this.setModelMat(this.currentPrism.baseModel)
        this.currentPrism.baseModel.visible = true;
        
        let gl = viewer.renderer.getContext();   
        viewer.renderer.setClearColor(new THREE.Color('#000'), 0);
        viewer.renderer.clear()
        
        viewer.renderer.render(this.scene,this.camera)  
        this.setModelMat(this.currentPrism.baseModel, 'recover')
        
        
        let pixelCount = this.renderTarget2.width * this.renderTarget2.height
		buffer2 = new Uint8Array(4 * pixelCount);
        
         
        //因为需要渲染完立即readPixels才能获取到，所以只能这时候就read了  
        gl.readPixels(0, 0, this.renderTarget2.width , this.renderTarget2.height, gl.RGBA, gl.UNSIGNED_BYTE, buffer2); //这句花费最多时间 pc:2-4， 即使只有1*1像素
        modelZs = [] //等待计算 
         
        if(window.needDownload) {
            let dataUrl = Potree.Utils.renderTargetToDataUrl(this.renderTarget2, this.renderTarget2.width, this.renderTarget2.height, viewer.renderer)
            Common.downloadFile(dataUrl, (name || 'screenshot') + '-' +   Date.now() +'.png')   
        }
        oldParent.add(this.currentPrism.baseModel)
        
        this.currentPrism.baseModel.visible = oldVisi
         
        viewer.renderer.setRenderTarget(oldTarget);
        
         
        this.renderTarget2.texture.needsRebuild = true //renderTarget在resize后会触发dispose， 然后 _gl.deleteTexture( textureProperties.__webglTexture )所以需要重新建立 否则图片变黑
        return this.renderTarget2.texture
    }
    
    
    
    
    
     
    getResByBound(boundSize, type){
        //let pxPerMetric = math.linearClamp(Math.max(boundSize.x,boundSize.y), [4, 10, 20, 80, 500, 2000], [300, 200, 100, 30, 6, 3])
        let pxPerMetric = math.linearClamp(Math.max(boundSize.x,boundSize.y), [ 10,  60,  100, 500, 2000], [150, 60, 40, 6, 3])
        let w = pxPerMetric * boundSize.x, h = boundSize.y * pxPerMetric
        
        let cW = 1 , cH = 1   //横向纵向渲染次数  超过maxWidth时分批渲染
        if(w > maxWidth || h > maxWidth){
            /* if(){//多数据集判断是否间隔过远，是的话返回
                
            } */ 
            if(type == 'forCompute'){//计算可以分多次渲染
                cW = Math.ceil(w / maxWidth), cH = Math.ceil(h / maxWidth)  
                w /= cW, h /= cH  
            }else if(type == 'forModel'){//但是model的贴图只能有一个
                if(w>h){
                    w = maxWidth, h = w * boundSize.y / boundSize.x
                }else{
                    h = maxWidth, w = h * boundSize.x / boundSize.y
                }
            }          
        }
        w = Math.round(w)
        h = Math.round(h)  
        return {w,h,pxPerMetric, cW,cH}
        
        
    } 
     
    //法1：只用一个顶部相机（当挖方遮挡填方时不准，但好算）
    async compute(prism, deferred_, getResolveResult){
        if(!prism || prism.modelHaventLoad){
            console.log('prism有问题') 
            return deferred_.reject() 
        }
        if(this.computingObject) return console.log('正在计算，请稍等')
             
        let oldCurPrism = this.currentPrism
        if(prism != this.currentPrism){//在列表外点击计算
            this.setCurrentPrism(prism)
        }
        
        let computeDone = ({highest,lowest,Vupper,Vlower}, deferred )=>{
            prism && prism.setVolumeInfo({
                highest,lowest,Vupper,Vlower   
            }) 
             
            if(oldCurPrism != prism){
                this.setCurrentPrism(oldCurPrism)
            }
            
            deferred && deferred.resolve(getResolveResult && getResolveResult())
            
        }
         
        if(prism.baseModel && this.boundSizeZero){ //bound没有交集 或 prism的boundsize为0
            return  computeDone({highest:0,lowest:0,Vupper:0,Vlower:0}, deferred_ )
        }
         
         
         

        
        
        this.computingObject = {prism, model: prism.baseModel} 
        deferred = deferred_  
         
        
        
        let computeFinish = (debugStr, makeit)=>{
            
            makeit || deferred.reject(interrupt ? '主动取消' : (debugStr || ''))
             
            this.computingObject = null
            deferred = null
            interrupt = false
            debugStr && console.log('computeFinish',debugStr)
            
            Potree.settings.displayMode = statesBefore.mode
            Potree.settings.pointDensity = statesBefore.pointDensity
            viewer.renderer.setRenderTarget(null);
            viewer.renderer.state.reset();
            viewer.renderer.setScissorTest(false);
            gl.disable(gl.SCISSOR_TEST); 
            
            
            viewer.screenshoting = false 
            viewer.mainViewport.active = true  
            viewer.mapViewer && (viewer.mapViewer.viewports[0].active = true )
            viewer.magnifier.viewport.active = true 
            viewer.pauseTestMaxLevel = false
            
        }
        
       
        
        let pointcloud = viewer.scene.pointclouds[0] 
        let center = new THREE.Vector3
        let boundSize = new THREE.Vector3
        let bound 
        let gl = viewer.renderer.getContext();        
        let statesBefore = {
            mode: Potree.settings.displayMode,
            pointDensity:Potree.settings.pointDensity
        }
        timestamp = Date.now() 
         
        if(!this.computingObject.model){
            horizonZ = prism.horizonZ
            zMin = prism.zMin
            zMax = prism.zMax
            bound = new THREE.Box3().copy(prism.prismBound)
            /* for(let i=0;i<prism.points.length;i++){
                bound.expandByPoint(prism.points[i])
            } */
        }else{
            zMin = this.computingObject.model.clipBound.min.z
            zMax = this.computingObject.model.clipBound.max.z
            bound = this.computingObject.model.clipBound
             
            //读取model的高度
            for (let u = 0; u < this.renderTarget2.width; u++) {
                let col = []
                for (let v = 0; v < this.renderTarget2.height; v++) { 
                    let offset = (u + v * this.renderTarget2.width); 
                    let rgb = buffer2.slice(4 * offset, 4 * offset+3), a = buffer2[4 * offset+3]  
                    if(a == 0 ){ //无点
                        col.push(null)
                    }else{
                        let z = this.convertColorToHeight(rgb, zMin, zMax) 
                        col.push(z)
                    }
                }
                modelZs.push(col)
            }  
        }
        
        lowest = zMax,  highest = zMin //init. to store pixel lowest and highest
        
        
        bound.getCenter(center)
        bound.getSize(boundSize) 
        
        this.boundSizeZero = boundSize.x<=0 ||boundSize.y<=0 || this.computingObject.model && boundSize.z<=0 //prism的问题
        if(this.boundSizeZero){
            computeDone({highest:0,lowest:0,Vupper:0,Vlower:0}, deferred )
            return computeFinish('finish', true)
        }
        center.z = zMax + this.camera.near + 0.1
        this.camera.far = zMax - zMin + 10 
        
        viewer.screenshoting = true
        
        viewer.pauseTestMaxLevel = true
         
        let {w, h, pxPerMetric, cW,cH } = this.getResByBound(boundSize, 'forCompute')
        
        
        this.camera.right = w / 2
        this.camera.left = -this.camera.right
        this.camera.top = h / 2
        this.camera.bottom = -this.camera.top 
        this.viewport.resolution.set(w , h)  
        this.renderTarget.setSize(w, h)
        
        
        wDelta = boundSize.x / (w * cW )
        sDelta = Math.pow(wDelta,  2) 
        
        //准备  
        Potree.settings.displayMode = 'showPointCloud'
        Potree.settings.pointDensity = 'screenshot'
        viewer.mainViewport.active = false //暂停渲染,否则影响这边点云的加载
        viewer.mapViewer && (viewer.mapViewer.viewports[0].active = false )
        viewer.magnifier.viewport.active = false //防止页面变白（似乎mainViewport被clear）
       
        
        {//material
        
            if(!this.computingObject.model){  
                //this.material.shape = Potree.PointShape.PARABOLOID;//加上之后depth出错，后排点云会挡前排，可pick时为什么不会？
                
                this.updateMatForModel(this.material, null) //计算时的shader这两种类型只能选一个，要么prism要么model，只能渲染一块区域
                //this.material.opacity = 1;
            }else{ 
                this.updateMatForModel(this.material, this.computingObject.model) 
                //this.material.opacity = 0.9; //为了输出透明度，负数高度的alpha是0.5
                
            }
            let clipBoxes_out = prism.clipBoxes.map(box=>{return {inverse:box.matrixWorld.clone().invert(),  box}} )
            this.material.setClipBoxes(null,[], clipBoxes_out,[],[prism]) 
           
           
            this.material.pointSizeType = 'FIXED'      //'ADAPTIVE' //node会自动根据的其level更改点大小 使用ADAPTIVE后会使baseModelMap整片是黑的，原因未知
            this.material.uniforms.minSize.value = 0.1
            this.material.uniforms.orthoMaxSize.value = 5; //px
             
            this.material.classification = pointcloud.material.classification;
            this.material.recomputeClassification(); 
            this.material.shaderNeedsUpdate = true
            pointcloud.updateMaterial(this.material, null, this.camera, viewer.renderer, this.viewport.resolution);
             
            this.material.size = 1//this.getPointsize(pointcloud.maxLevel)   //0.025  米   //视图缩小（截图面积变大）后点会自动缩小，但至少是1个像素大小
            
        }
        
        
        
        
        
        
	  
		viewer.renderer.state.buffers.depth.setTest(this.material.depthTest);
		viewer.renderer.state.buffers.depth.setMask(this.material.depthWrite);
		viewer.renderer.state.setBlending(THREE.NoBlending);  //只需要设置不透明即可（使alpha不混合，后方不会影响前方的alpha，否则输出的a通道将没法用）
        
          
        
        
        
        let pixelCount = this.renderTarget.width * this.renderTarget.height
		buffer1 = new Uint8Array(4 * pixelCount);
        
        viewer.renderer.setRenderTarget(this.renderTarget);
      
        let results = []
        let boundSize_ = boundSize.clone()
            boundSize_.x /= cW,  boundSize_.y /= cH 
        
        
        
          
        
        
        
        
        //分批渲染：从左到右 从下到上
        for(let i=0; i<cW; i++){
            for(let j=0; j<cH; j++){
                let infos = [] 
                
                let progressStart = (i*cH + j) / (cW * cH) ,   progressEnd = (i*cH + j+1) / (cW * cH)
                 
                if(interrupt){
                    return computeFinish('23')
                }
                Potree.settings.pointDensity = 'screenshot'       //恢复为nodeMaxLevel
                //最高处朝下看，找挖方的顶部
                this.view.pitch = -Math.PI / 2; 
                let endPosition = new THREE.Vector3(center.x + (i-cW/2+0.5) * boundSize_.x,  center.y + (j-cH/2+0.5) * boundSize_.y,  center.z)
                this.view.moveOrthoCamera(this.viewport,  {boundSize: boundSize_, endPosition }, 0)
                let endPercent = this.computingObject.model ? 0.7 : 0.4
                await this.render({i,j,index:1,cW,cH, infos,   /* maxLevels, */ notifyArea:[[progressStart, progressEnd],[0,endPercent]], computeFinish })
                 
                
                if(interrupt){
                    return computeFinish('2123')
                }
                
                  
                 
                if(!this.computingObject.model){ 
                    //水平面朝下看，找填方
                    this.view.position.z = horizonZ + this.camera.near  
                    await this.render({i,j,index:2, cW,cH, infos,   /* maxLevels, */ notifyArea:[[progressStart, progressEnd], [0.4, 0.7]], computeFinish})   
                }
                    
                    
                    
                    //水平面朝上看，找挖方的底部
                   /*  this.view.position.z = horizonZ + surfaceThick //排除地面（水平面）上的点
                    this.view.pitch = Math.PI / 2; 
                    await this.render({reverseRow:true,name:'第3张-'+i+'-'+j, infos, buffer,maxLevels }) *///---土堆上有草地有厚度，还是去掉吧
                    
                    let result = {
                        index : {i,j}, 
                        allFills:[],
                        fillVupper:0 ,
                        fillVlower:0 ,
                        Vupper : 0, 
                        Vlower : infos[1] ? infos[1].Vlower : infos[0].Vlower , // >= infos[0].Vlower 因能找到被上方遮挡住的凹槽
                        allDiffHeights : [],
                        fillVupperCount:0,
                        fillVlowerCount:0,
                        infos
                    }
                    
                    
                    let waitFill = [];
                    waitFill.count = 0
                    let isNeighbor = (a,b)=>{
                        return Math.abs(a.u - b.u ) <= 1 && Math.abs(a.v - b.v ) <= 1    
                    }
                    let isBelongToGroup = (group, item)=>{
                        if(item[0])item = item[0]
                        
                        let i=group.length  
                        while(--i >=0){//从后往前
                            if(item.u-group[i].u > 1 && Math.abs(item.v-group[i].v) > 1) break //距离超出，前面肯定不相邻了
                            
                            if(isNeighbor(group[i], item)){
                                return true
                            }
                        }
                    }
                    
                    
                    
                    
                    //计算挖方（但是边缘附近垂直方向上很多点云，体积被削皮，最终得到的会比infos[0]少）
                    
                    let getValue = (u,v)=>{//当到了左上边界是否需要向前几批的查找？
                        if(infos[0].allHeights[u] && infos[0].allHeights[u][v] != void 0 )return infos[0].allHeights[u][v] 
                        return result.allFills[u] && result.allFills[u][v]  
                    }
                    let hasValue = (u,v)=>{//在边界内
                        return u >= 0 && u < infos[0].allHeights.length && v >= 0 && v < infos[0].allHeights[0].length
                    }
                    
                    
                    let getFill = (u,v)=>{//使用周围的八个点的平均值补洞

                        let neighbours = [ [-1,0],[0,1],[1,0],[0,-1], [-1,-1], [1,-1], [-1,1],[1,1]]//先左右右先上后下
                        let i=0, c=0, sum=0
                        
                         
                        while(c<4 && i<8){
                            let x = neighbours[i][0]+u, y = neighbours[i][1]+v;
                            if(hasValue(x,y)){
                                let neigh = getValue(x,y)
                                if(neigh != void 0){
                                    c++;
                                    sum += neigh  
                                }else if(i>=3){
                                    //add 2024.5.27 
                                    if(c == 0)break //节省时间，主要为了大片透明区域
                                } 
                                 
                            }
                            
                            
                            i++;
                             
                        } 
                        if(c>0){  
                            sum /= c;  
                            result.allFills[u] || (result.allFills[u] = [])
                            result.allFills[u][v] = sum 
                            return sum
                        }
                    }
                    
                     
                    let add = (v, fill, count)=>{
                        if(v > 0){
                            result.Vupper += v 
                            fill && (result.fillVupper+=v, result.fillVupperCount += count)
                            
                        }else{//fill的话才会有 
                            fill && (result.fillVlower-=v, result.fillVlowerCount += count)   
                        }
                    }
                    
                    
                    
                        
                    let compute = async (u,v)=>{
                        
                        let top = infos[0].allHeights[u][v]
                        //let btm = infos[2].allHeights[u][v]
                        let fill 
                        if(top == void 0){
                            
                            if(prism){
                                
                                let x = endPosition.x - boundSize_.x /2 + wDelta * (u + 0.5)
                                let y = endPosition.y - boundSize_.y /2 + wDelta * (v + 0.5)
                                if(!math.isPointInArea(prism.points, null, {x,y}) ){ 
                                    return //出界
                                }
                            }else{
                                if(this.getModelZByRes(u,v,cW,cH,i,j) == void 0){
                                    return //出界
                                }  
                            }
                            
                            
                             
                            fill = true  
                            top = getFill(u,v) 
                            if(top == void 0){  //左侧边缘有缺口时会出现
                                
                                if(waitFill.cancel || waitFill.count > 1000 && waitFill[waitFill.length-1][waitFill[waitFill.length-1].length-1].u - waitFill[0][0].u  > 4){ //跨度超过4列
                                    waitFill.cancel = true //丢弃，不加入补洞, 降低耗时 
                                }else{ 
                                    Common.pushToGroupAuto([{u,v}], waitFill, null, isBelongToGroup) //按邻近点分组
                                }
                                
                                waitFill.count ++   //当数量达到几万以上会在这个地方花很长时间，不过很少出现这种情况
                                
                                return
                            }                            
                        }
                        /* let diff = top-btm
                        let useDiff 
                        if(btm != void 0 && diff > surfaceThick  ){ 
                            useDiff = diff   
                            result.allDiffHeights.push(useDiff)        
                        }else{ 
                            useDiff = top        //从顶部一直到水平
                        }*/
                        
                        if(waitFill.length){//补  之前没有值的邻居重新获取
                            if(interrupt){
                                return computeFinish('12312')
                            } 
                            
                            if(waitFill.cancel){
                                //console.log('直接清空waitFill', waitFill.count, waitFill.map(list=>[list[0], list[list.length-1]]))
                                waitFill.count = 0
                                waitFill.length = 0
                                waitFill.cancel = false
                            }else{
                                ///* //Potree.settings.isTest &&   */ waitFill.count>1000 &&  console.log('waitFill.count', waitFill.count, 'groupLen', waitFill.length, waitFill[0][0], waitFill[0][waitFill[0].length-1])
                                waitFill.slice().forEach(group=>{ //每个组都看看是否跟它相邻
                                    if(isBelongToGroup(group, {u,v})){ 
                                        let index = waitFill.indexOf(group)
                                        waitFill.splice(index,1)
                                        waitFill.count -= group.length  
                                        group.forEach(e=>{
                                            result.allFills[e.u] || (result.allFills[e.u] = [])
                                            result.allFills[e.u][e.v] = top //该组全部都使用该体积
                                        })
                                        let sum = top * group.length
                                        add(sum, fill, group.length) 
                                        
                                    }  
                                })
                            }                            
                        }
                          
                        add(top, fill, 1)
                    }
                    
                    
                    
                    
                    let lastNotifyTime = Date.now()  
                    //从左到右，从下到上一列列扫描
                    for (let u = 0; u < this.renderTarget.width; u++) {  
                        for (let v = 0; v < this.renderTarget.height; v++) { //数据是从图的下到上存储的
                             
                            if(interrupt){
                                return computeFinish('1121')
                            } 
                            compute(u,v);
                        }   
                        await notify([[progressStart, progressEnd], [0.7, 1]]  , ()=>{return u / this.renderTarget.width }, 'compute')
                        
                    }
                    
                    if(waitFill.length){
                        console.log('waitFill怎么还有？？', waitFill)//如果是模型的话是有剩的可能，当它的周围刚好是模型的hole时，就被断开在孤立的组里了，如"回"字型，中间的口是有model但无点云处，外面的口是无model处。
                    }
                    result.Vupper *= sDelta
                    result.fillVlower *= sDelta
                    result.fillVupper *= sDelta
                    
                    result.Vlower += result.fillVlower
                    
                    results.push(result)
                 
                    
                    
                    
                    
                    
                 
                deferred && deferred.notify(progressEnd)                
            }
        }
               
        
        let Vupper = 0, Vlower = 0, fillVlower = 0,  fillVupper = 0
        results.forEach((c)=>{
            Vupper += c.Vupper; Vlower += c.Vlower;
            fillVlower += c.fillVlower; fillVupper += c.fillVupper; 
        })
      
         
         
        computeDone({
            highest,lowest,Vupper,Vlower, 
        }, deferred)
        
        
        computeFinish('finish', true)
         
        
        console.log( {Vupper,Vlower,  oldVupper: Vupper - fillVupper, oldVlower:  Vlower - fillVlower, highest,lowest, horizonZ, wDelta}, results, this.viewport.resolution, {cW,cH}, 'cost:', Date.now()-timestamp, 'pxPerMetric', pxPerMetric, 'boundSize',boundSize )//firefox用时是chrome两倍,edge和chrome差不多
    }
   
    
    
    
    
    
    
    
    getModelZByRes(u,v, cW,cH,wIndex,hIndex){ //传入renderTarget2的像素index
        //如果两个map的尺寸不同 
        let x = Math.round(wIndex/cW + u/this.renderTarget.width * this.renderTarget2.width);
        let y = Math.round(hIndex/cH + v/this.renderTarget.height * this.renderTarget2.height);
        let z0 = modelZs[x][y]  
        return z0
        
        
        //return modelZs[u][v]
    }
    
    
    
    
    async render({i,j, index, cW,cH, reverseRow,  infos,  /* maxLevels, */ notifyArea, computeFinish}={}){ 
        this.view.applyToCamera(this.camera)   
        Potree.updatePointClouds(viewer.scene.pointclouds, this.camera, this.viewport.resolution );
        let gl = viewer.renderer.getContext();
        let screenshot = (name)=>{
            //if(window.testScreen){            
                let dataUrl = Potree.Utils.renderTargetToDataUrl(this.renderTarget, this.renderTarget.width, this.renderTarget.height, viewer.renderer)
             
                Common.downloadFile(dataUrl, (name || 'screenshot') + '-' +  timestamp +'.png')  //为什么图片上不是只有pickWindowSize区域有颜色？？
                   
            //} 
        } 
        let name = i+'-'+j+'-第'+index+'张'
        console.log('开始渲染', name)
    

        let camera = this.camera
        let viewport = this.viewport
        
        return new Promise((resolve,  reject)=>{
            
            let done = async ()=>{ 
                gl.clearColor(0, 0, 0, 0);
                viewer.renderer.clear(true, true, true);
                  
                //viewer.pRenderer.renderOctree(pointcloud, nodes, this.camera,  this.renderTarget ,{material:this.material});
                viewer.pRenderer.render(viewer.scene.scenePointCloud, this.camera, this.renderTarget ,{material:this.material , /* transparent:!this.computingObject.isPrism  */ });  
                
                if(interrupt){
                    return (reject(), computeFinish('re 23')) 
                }
                
                Potree.settings.isTest && screenshot(name);
                gl.readPixels(0, 0, this.renderTarget.width , this.renderTarget.height, gl.RGBA, gl.UNSIGNED_BYTE, buffer1); //这句花费最多时间 pc:2-4， 即使只有1*1像素
                 
                notifyArea.push([progressEnd1,1])
              
                let Vupper = 0, Vlower = 0
                 
                let upperHeights = [],lowerHeights = [], allHeights = []
                
                for (let u = 0; u < this.renderTarget.width; u++) {
                    let col = []
                    
                    for (let v = 0; v < this.renderTarget.height; v++) {
                        let _v = reverseRow ? this.renderTarget.height - v - 1: v
                        let offset = (u + _v * this.renderTarget.width); 
                        let rgb = buffer1.slice(4 * offset, 4 * offset+3), a = buffer1[4 * offset+3]  
                        if(a == 0  /* rgb[0] == 0 && rgb[1] == 0 && rgb[2] == 0  */){ //无点
                            col.push(null)
                        }else{
                            let z = this.convertColorToHeight(rgb, zMin, zMax) 
                            let h
                            if(!this.computingObject.model){  
                                h = z - horizonZ 
                            }else{     //和baseModel标准面之间的高度差
                                /* if(a == 128){//负数
                                    h = -h
                                } ///如果这个也要lowest 那需改shader ，shader不计算高度差  
                                 */
                                let z0 = this.getModelZByRes(u,v, cW,cH,i,j)
                                h = z - z0
                            }
                            z < lowest && (lowest = z) //上表面最低点  
                            z > highest && (highest = z) //上表面最高点 
                            
                            if(h>0){
                                Vupper += h
                                upperHeights.push(h) //
                            }else{
                                Vlower += -h
                                lowerHeights.push(h)
                            }
                             
                            
                            col.push(h)
                        } 
                        
                        if(interrupt){ 
                            return (reject(), computeFinish('re 023'))
                        }
                        //notify(notifyArea,    (u*this.renderTarget.height + v) /(this.renderTarget.width*this.renderTarget.height))        
                    }
                    allHeights.push(col)
                    
                    
                    await notify(notifyArea,  ()=>{return  u / this.renderTarget.width},  'readPixels get')
                    
                    
                    
                    
                }
                Vupper*=sDelta
                Vlower*=sDelta
                    
                infos.push({Vupper,Vlower,sDelta,upperHeights,lowerHeights,allHeights})
                resolve()   
            }
             
         
            //let finish  , maxTime = 1e6
            let progressEnd1 = math.linearClamp( this.camera.zoom, [1,1000], [0.8,0.2]) //放得越大，实际加载的点云相对越少，费时越少
            let notifyArea_ = [...notifyArea, [0, progressEnd1]] 
            
            if(Potree.pointsLoading ){  //如果有要加载的node
                

                let curProgress = 0,  beginTime = Date.now(), unloadBefore,
             
                    tryPreLoadTime = Math.round(math.linearClamp(buffer1.length/this.camera.zoom/this.camera.zoom, [50,10000],[1000,15000])) 
                    //console.log('tryPreLoadTime',tryPreLoadTime)
            
                let decreaseLevel = ()=>{ //降点云level 
                     //暂时先都一起降1 
                     let pointclouds = viewer.scene.pointclouds.filter(e=>e.visibleNodes.length)
                     console.log('准备decreaseLevel， numVisiblePoints', Potree.numVisiblePoints, '最小numVisiblePoints占比',  1/pointclouds.length )
                     
                     pointclouds.forEach(e=>{
                         let percent = e.numVisiblePoints / Potree.numVisiblePoints
                         console.log('numVisiblePoints占总比', e.dataset_id, percent )
                         if(percent < 1/pointclouds.length)return
                         
                         let old = e.maxLevel
                         let levels = e.visibleNodes.map(e=>e.getLevel())  
                         let actMaxLevel = Math.max.apply(null, levels) //实际加载到的最高的node level
                         e.maxLevel = actMaxLevel - 1
                         console.warn(e.dataset_id,'decreaseLevel,新maxLevel', actMaxLevel - 1, '原maxlevel', old   ) 
                       
                         //this.material.size = this.getPointsize(e.maxLevel)
                         //this.material.size *= 2
                     }) 
                     
                }
                let finish = (makeit)=>{
                    //viewer.removeEventListener('overPointBudget',decreaseLevel)
                    makeit && done() 
                    viewer.removeEventListener('update',update)
                    viewer.removeEventListener('pointsLoaded',loaded) 
                }
                let update = ()=>{  
                    Potree.updatePointClouds(viewer.scene.pointclouds, camera, viewport.resolution );
                    /* if( Potree.numVisiblePoints > maxPointBudge * 0.9){ 
                        decreaseLevel() 
                     */
                    notify(notifyArea_,  ()=>{ 
                       /* console.log('unloadedGeometry',Potree.unloadedGeometry.length)
                       
                       return curProgress */
                       
                       
                       /* curProgress = THREE.Math.clamp(Potree.numVisiblePoints/predictPointCount,curProgress,1) //如果decreaseLevel了点会减少，也不管它，就停住吧，反正很快就加载好了
                       return curProgress */
                       
                     
                       if(!unloadBefore && Date.now() - beginTime < tryPreLoadTime){
                            curProgress = (Date.now() - beginTime) / tryPreLoadTime * 0.5
                       }else{
                            if(!unloadBefore){
                                unloadBefore = Potree.unloadedGeometry.length
                                //console.log('unloadBefore', unloadBefore)
                            }                                
                            unloadBefore = Math.max(Potree.unloadedGeometry.length, unloadBefore) //unloadedGeometry 刚开始可能越涨越多 - - 所以进度条会卡住
                            
                            let curProgress_ = 0.5 + 0.5 * (1 - Potree.unloadedGeometry.length / unloadBefore )  
                            
                            curProgress = Math.max(curProgress,curProgress_)
                            
                       } 
                       
                       //console.log('curProgress ', curProgress, 'numVisiblePoints', Potree.numVisiblePoints, 'unloadedGeometry',Potree.unloadedGeometry.length)
                       
                       return curProgress 
                    }, 'loadpoints')        
                    
                    
                    interrupt && (finish(false),  reject(), computeFinish('正在loadPoints,unloadedGeometry个数'+Potree.unloadedGeometry.length )) //曾经遇到遇到bug 不发送pointsLoaded 一直update  一直有3个unloadedGeometry加载不了。。 是否为每个加载的node加个计时？
                } 
                viewer.addEventListener('update',update)
                
                let loaded = ()=>{ //点云加载完时（不一定准确）  
                    console.warn('加载完毕', ' numVisiblePoints', Potree.numVisiblePoints )                         
                    finish(true)
                } 
                viewer.addEventListener('pointsLoaded', loaded)
                
                 
                
                
                
              
                /* let predictPointCount = Math.round(math.linearClamp(buffer.length, [1e5, maxWidth*maxWidth*4],[1e6,  maxPointBudge ]))//最终要加载到的数目
                 */
                 
                
                /* let overTime = ()=>{
                    if(document.hidden){
                        return setTimeout(overTime, maxTime)  
                    }
                    if(!finish)console.warn('超时, numVisiblePoints', Potree.numVisiblePoints)  
                    dealDone()
                }
                 
                setTimeout(overTime, maxTime) */
            }else{
                notify(notifyArea_,  1) 
                done()
            }  
        })
        
    }
    
     
    convertColorToHeight(color, zMin, zMax){
        let percent = 0
        let a = 1 
        for(let i=0;i<3;i++){
            a = i == 2 ? a/255 : a / 256 
            percent += a * color[i];
        }
        let height = (zMax - zMin) * percent
        return height + zMin; 
    }
    
    
    getPointsize(maxLevel){//尽量铺满  size单位是米，需要和点云缝隙同宽
    
        return 0.01       /* adaptive:0.2 */
         
        
        
        let s =  /* this.material.spacing */ 100 / Math.pow(2, maxLevel - 1)  //adaptive的话在shader中已经乘了spacing  
        console.log('getPointsize', s, 'maxLevel',maxLevel)
        return s  //会不会直接返回1就好？  
        //不能太小。假如gl_pointsize计算结果是0.1,那么显示就是1px；当level将级后，放大2倍为0.2，也还是1px，看起来就稀疏了。所以要保证这个数在最大level时gl_pointsize计算结果差不多是1px.(虽然我会在渲染大尺寸面积时降画布尺寸，但不能保证刚刚好，且因点云个数不可控不会降尺寸太狠)
    } 
    
    
    download(prisms){
        
        if(this.prisms.length == 0){
            return null
        } 
        
        
        var visiPointclouds = viewer.scene.pointclouds.filter(e=> Potree.Utils.getObjVisiByReason(e, 'datasetSelection'))
        visiPointclouds.sort((a,b)=>{return a.dataset_id-b.dataset_id})//缓存需要固定排序好比较
        
        let data = {   
            transformation_matrix: visiPointclouds.map((cloud)=>{
                let data = {
                    id: cloud.dataset_id, 
                    matrix: new THREE.Matrix4().elements,  //参照downloadNoCrop，给默认值，表示没有最外层裁剪
                    visiMatrixes: prisms.map(prism=>{return {
                        matrix: prism.getTransformationMatrix(cloud).elements,//剪裁框
                        points: prism.points.map(p=>{return {x:p.x,  y:p.y}})
                    }}), 
                    modelMatrix:(new THREE.Matrix4).copy(cloud.transformMatrix).transpose().elements
                }  
                return data
            }) ,
            aabb: "b-12742000 -12742000 -12742000 12742000 12742000 12742000" //剪裁空间 
        }
        
        return data
    }
    
    
    //体积多边形棱柱，z需要变换到-0.5 ~ 0.5
    

}


 
/* VolumeComputer.prototype.setClipBoxes = function(){
    let lastPrisms = []
    
    return function(){
        let prismPolygons = this.prisms.filter(e=>!e.isNew && e.visible) 
        
        let prismList = [], prismPoints = [], maxPointsCount
        if(prismPolygons.length){  
            let pointsCount = prismPolygons.pointsCount = prismPolygons.reduce((w,c)=>{return w+c.points.length},0) 
            prismList = new Float32Array(9 * prismPolygons.length); 
            prismPoints = new Float32Array(2 * pointsCount);
            
            prismPolygons.maxPointsCount = 0//单个prism最大点个数 
             
        if(!this.entered)this.enter()
            
            let pointIndex = 0
            for(let i=0;i<prismPolygons.length;i++ ){ 
                let bound = prismPolygons[i].prismBound 
                let z = prismPolygons[i].horizonZ 
                //z = Potree.browser.urlHasValue('zmin',true) ||  zs[0]  
                prismList.set([bound.min.z, z, bound.max.z, bound.min.x, bound.max.x, bound.min.y, bound.max.y,  prismPolygons[i].points.length ],9*i);
               
                //prismList.push(new THREE.Matrix3().fromArray([bound.min.z, z, bound.max.z, bound.min.x, bound.max.x, bound.min.y, bound.max.y,  prismPolygons[i].points.length,0 ]))
                
                for(let j=0;j<prismPolygons[i].points.length;j++){
                    prismPoints.set([prismPolygons[i].points[j].x, prismPolygons[i].points[j].y] , 2*j+pointIndex);
                    //prismPoints.push( new THREE.Vector2().copy(prismPolygons[i].points[j]))
                }  
                pointIndex += 2 * prismPolygons[i].points.length
                
                
                prismPolygons.maxPointsCount = Math.max(prismPolygons.maxPointsCount, prismPolygons[i].points.length) 
            } 
            
        }  
     
     
    
        let doUpdate = ( lastPrisms.length != prismPolygons.length) || lastPrisms.maxPointsCount != prismPolygons.maxPointsCount                                                                                                                                                                                                                                                                                                                                                                              
        
         
        let materials = viewer.scene.pointclouds.map(e=>e.material).concat([this.material])
        
        materials.forEach(e=>{
            e.uniforms.prismList.value = prismList
            e.uniforms.prismPoints.value = prismPoints
            e.shaderNeedsUpdate = e.shaderNeedsUpdate || doUpdate
            e.prisms = prismPolygons 
        })
        

        //修改obj材质
        this.material.defines.num_prism = this.material.prisms.length//土方量数
        this.material.defines.prismPointCountSum = this.material.prisms.pointsCount //点总个数
        this.material.defines.prism_maxPointsCount = this.material.prisms.maxPointsCount //单个prism最大点个数
        if(doUpdate){
            this.material.needsUpdate = true 
            viewer.dispatchEvent('content_changed')
        }
        lastPrisms = prismPolygons
        
        
    }            
}(); */




/* 

    渲染像素pxPerMetric越高，边缘越细腻、准确；   点size越小，越不容易遮盖住下方点云，造成体积偏大。但会不会有底部点云透出来？


    该版本计算用到两张截图，第一张为整体的俯视图，包括挖方和填方；第二张仅包含填方。
    缺陷：在补洞时，只利用第一张图的结果，所以整体的挖方会偏多，填方偏少（因为在挖方填方同时存在时，没有分别补挖方和填方，而是放在一起，而上方可能遮盖下方的）
    尝试过第一张只绘制挖方部分，但是在遍历时就需要多遍历一次，测得的用时更多一些，结果却没变化
    也尝试过补洞时挖方填方分别补各自的，但这样要考虑更多的东西，用时多了两倍以上。（因为目前规定无论范围内实际有没有点云都补上，非挖即填；如果分开的话，填方边缘也都补上肯定是错的，无法找到挖和填的界限，无法分清是只有挖还是填还是两者均有。如果要探测周围点，耗时很多）
    




    如果数据集修改了，土方量需要手动重算。所以场景刷新后显示的体积有可能是错的。
    之前记的，太麻烦了，延期处理：
        1 一般情况：我需要记录每个土方量范围内存在的数据集的位置，如

        {datasetId:"1745733728954093568", location:[113.59550104511611, 22.36677932324081, 0] ，orientation: 0.1}

        如果刷新后土方量范围内存在的数据集发生改变，将重算。
        
        数据集也可能显示或隐藏

        2 其他特殊情况，如裁剪，难以知道裁剪了哪块，所以只能全部重算
 



    ------------------
    
    baseModel 基于模型的挖方填方
    由于模型高度不一致，只能把相机放最高处朝下看，而无法像prism那样在horizonZ处再渲染一张，所以更加不能有多层点云干扰。
    如模型在一个房间屋顶上方，那么填方会得到两个高度，屋顶和地板的高度，地板是从屋顶的点云缝隙而得。
    如果模型放房间中间，并不能按理想的那样得到其上的挖方和其下的填方，因为相机朝下看时屋顶会遮住屋底，导致填方减少挖方增多。虽然能在bound底部朝上再拍一张，但若是有更复杂的情况依旧不能保证正确。
    故需要设置好zMin zMax

    如果模型有可能很大，但数据集不大，可以将bound只取交集

 */